{
  "de": {
    "company": {
      "noMembership": {
        "card1": {
          "heading": "Zugang zu Lizenzgruppe aktivieren",
          "description": "Deine Einrichtung hat bereits eine Lizenz? Gib den 8-stelligen Aktivierungscode ein, um deinen Zugang zu aktivieren."
        },
        "card2": {
          "heading": "Noch keine Lizenz vorhanden?",
          "description": "Mit einer Lizenz für deine Schule oder Bildungseinrichtung kannst du fobizz gemeinsam mit Kolleg*innen nutzen. Tipp: Eine Lizenz lohnt sich häufig schon ab 5 Personen!",
          "groupLicenseLink": "Mehr zur Gruppenlizenz erfahren",
          "consultationLink": "Beratungstermin vereinbaren"
        }
      },
      "shell": {
        "school": "Meine Schule",
        "workshops": "Interne Workshops",
        "material": "Mein Material",
        "certificate": "Zertifikat",
        "administration": "Lizenzverwaltung",
        "adminInfo": "Aktuelles",
        "adminMemberships": "Mitglieder und Lizenz",
        "adminEvaluations": "Auswertung",
        "adminLegals": "Rechtliches",
        "internal": "fobizz intern",
        "selectSchool": "Schule auswählen",
        "switchSchool": "Ansicht wechseln",
        "selectGroup": "Zeitraum auswählen"
      },
      "overview": {
        "endedAlert": "Die Laufzeit der Gruppe ist beendet. Bitte nehmen Sie Kontakt auf.",
        "internalAnnouncements": "Interne Ankündigungen",
        "internalAnnouncementsAdminInstructions": "Als Ansprechperson dieser Lizenzgruppe können Sie in diesem Bereich individuelle Empfehlungen hinterlegen.",
        "editAnnouncements": "Interne Ankündigungen bearbeiten",
        "saveAnnouncements": "Nachricht aktualisieren",
        "cancelAnnouncements": "Abbrechen",
        "selectedCourses": "Empfehlungen",
        "license": "Meine Schullizenz",
        "yourContact": "Deine Ansprechperson ist | Deine Ansprechpersonen sind",
        "licenseHint": "Informationen zu deinen Lizenzen findest du unter <a href=\"/profile/licenses\" class=\"fw-semibold\">Meine Lizenzen</a>."
      },
      "workshops": {
        "heading": "Interne Workshops",
        "paragraph": "Lerne gemeinsam mit deinem Kollegium in unseren internen Workshops und Vorträgen.",
        "link": "Interne Angebote entdecken",
        "current": "Aktuelle Workshops",
        "past": "Vergangene Workshops"
      },
      "certificate": {
        "congratulations": "Glückwunsch!",
        "courseCompleted": "Du hast die Zusatzqualifikation erfolgreich abgeschlossen.",
        "downloadPrompt": "Lade dein Zertifikat jetzt herunter.",
        "surveyPrompt": "Deine Meinung ist uns sehr wichtig. Gib uns bitte kurz Feedback zur Zusatzqualifikation.",
        "surveyLink": "Feedback geben",
        "downloadLink": "Herunterladen"
      },
      "material": {
        "heading": "Unterrichtsmaterial",
        "fields": {
          "title": "Thema",
          "url": "URL zu meinem Ergebnis in den fobizz Tools",
          "acceptShared": "Ja, ich stimme zu, meine Dateien mit fobizz und anderen Lehrkräften innerhalb der fobizz Plattform zu teilen."
        },
        "urlHelp": "Reiche hier dein Unterrichtsmaterial ein. Nutze die Vorlage, um deine Inhalte darzustellen und einzubinden. Wichtig: Teile den Vorschaulink.",
        "submit": "Material einreichen",
        "edit": "Bearbeiten",
        "back": "Zurück",
        "confirmationHint": "Dein Projekt ist erfolgreich bei uns eingegangen. Eine extra Eingangsbestätigung per Mail wird dazu nicht versendet."
      },
      "adminLegals": {
        "heading": "Rechtliches"
      },
      "adminReports": {
        "heading": "Einschreibungen",
        "allLicensesEnrollments": "Einschreibung über alle Lizenzen dieser Einrichtung | Einschreibungen über alle Lizenzen dieser Einrichtung",
        "licenseEnrollments": "Einschreibung über diese Lizenz | Einschreibungen über diese Lizenz",
        "topic": "Fortbildungstitel",
        "count": "Anzahl"
      },
      "adminEvaluations": {
        "heading": "Auswertung",
        "intro": "Hier finden Sie eine zusammenfassende Auswertung des Feedbacks innerhalb dieser Gruppe.",
        "noFeedback": "Bisher ist noch nicht ausreichend Feedback für eine Auswertung der Fortbildungen vorhanden. Haben Sie noch ein wenig Geduld.",
        "rating": "Wie wurden die Fortbildungen durchschnittlich bewertet?",
        "noRating": "Keine Sternebewertungen vorhanden.",
        "recommendationScore": "Wie ist die durchschnittliche Weiterempfehlungsquote von fobizz?",
        "noRecommendationScore": "Keine Weiterempfehlungsquote vorhanden.",
        "publicComment": "Was sagen die Mitglieder zu den Fortbildungen?",
        "publicCommentTooltip": "Gut zu wissen: Die Rezensionen sind freiwillig abgegeben. Öffentliche Rezensionen werden nur von wenigen Personen geschrieben.",
        "noPublicComment": "Keine Rezensionen vorhanden.",
        "metabaseDashboard": "Metabase Auswertungs-Dashboard",
        "schoolFilter": {
          "label": "Nach Schule filtern",
          "allSchools": "Alle Schulen"
        }
      },
      "adminMemberships": {
        "heading": "Mitglieder und Lizenz",
        "inviteMembers": "Mitglieder einladen",
        "manageMembers": "Mitglieder verwalten",
        "searchPlaceholder": "Name oder E-Mail...",
        "search": "Suchen...",
        "copySuccess": "Link kopiert!",
        "members": "Mitglied | Mitglieder",
        "summary": {
          "groupAdmin": "fobizz Koordinator*innen",
          "manageAdmins": "Admins verwalten",
          "orderEndsAt": "Ende der Schullizenz",
          "package": "Lizenzpaket",
          "requestMoreLicenses": "Weitere Lizenzen anfragen"
        },
        "activationCode": {
          "title": "Aktivierungscode für neue Mitglieder",
          "description": "Mit diesem Code können alle Kolleg*innen über {url} dieser Lizenzgruppe beitreten.",
          "copyButton": "Link inkl. Code kopieren"
        },
        "invitationOptions": {
          "title": "Weitere Optionen, um neue Mitglieder in die Gruppe einzuladen:",
          "emailCard": "Einladung per Mail",
          "posterCard": "Aushang drucken",
          "linkCard": "Link inkl. Code kopieren"
        },
        "table": {
          "name": "Name",
          "email": "E-Mail-Adresse",
          "status": "Status",
          "createdAt": "Beitritt am",
          "actions": "Aktionen"
        },
        "actions": {
          "extend": "Verlängern",
          "remove": "Entfernen"
        },
        "confirm": {
          "extend": {
            "title": "Laufzeit verlängern?",
            "text": "Die Laufzeit für {name} wird verlängert. Eine Verlängerung entspricht einer Lizenz."
          },
          "remove": {
            "title": "Mitglied entfernen?",
            "text": "Diese Aktion kann nicht rückgängig gemacht werden. {name} wird aus der Gruppe entfernt und verliert den Zugang zur Schullizenz."
          }
        },
        "error": {
          "actionFailed": "Die Aktion konnte nicht ausgeführt werden. Ein Neuladen der Seite zeigt den aktuellen Stand.",
          "invitationFailed": "Die Einladung konnte nicht gesendet werden. Ein Neuladen der Seite zeigt den aktuellen Stand."
        },
        "pagination": {
          "previous": "Zurück",
          "next": "Weiter",
          "page": "Seite {current} von {total}"
        },
        "emailModal": {
          "title": "Einladung per E-Mail senden",
          "placeholder": "Alle E-Mail-Adressen eingeben",
          "hint": "Gib die E-Mail-Adressen aller Personen ein, die eine Einladung erhalten sollen.",
          "helpInvalidAddresses": "Ungültige Adressen werden rot markiert.",
          "helpMailingLists": "Verteiler-Adressen sind nicht geeignet.",
          "submit": "Senden"
        }
      },
      "license": {
        "courses": {
          "title": "Fortbildungs-Schullizenz",
          "description": "Zugriff auf alle fobizz-Fortbildungen, inkl. KI-Fortbildungen",
          "linkLabel": "Zum Fortbildungskatalog"
        },
        "tools": {
          "title": "Tools-Schullizenz",
          "description": "Zugriff auf fobizz-Tools für den Unterricht, inkl. KI-Tools und KI-Klassenräume für SuS",
          "linkLabel": "Tools-Schullizenz"
        },
        "toTeach": {
          "title": "to teach-Schullizenz",
          "description": "Pro-Zugang für das Kollegium für to teach: Differenzierbare Unterrichtsvorbereitung und Materialien",
          "linkLabel": "to teach-Schullizenz"
        },
        "status": {
          "active": "aktiv",
          "trial": "Probelizenz",
          "exceeded": "Abgelaufen",
          "nonActive": "nicht aktiv",
          "confirmed": "bestätigt"
        },
        "activeUntil": "Zugang gültig bis",
        "activeFrom": "Zugang gültig von {startDate} bis {endDate}",
        "generalActiveUntil": "Lizenz gültig bis",
        "upgradeText": "Dazu buchen für {months} Monate:",
        "requestUpgrade": "Erweiterung anfragen",
        "renewalHeadline": "Verlängerungshinweis",
        "renewalText": "Für die Gruppe \"{groupName}\" ist bereits eine Verlängerung gebucht. Die neue Lizenz für {licenses} startet ab dem {startsAt}."
      },
      "membershipExceeded": {
        "member": {
          "heading": "Deine Lizenz ist leider beendet.",
          "paragraph": "Sprich mit der Ansprechperson deiner Schule und erkundige dich darüber, wie ihr als Schule fobizz weiterhin nutzen könnt.",
          "paragraphWithContact": "Sprich mit der Ansprechperson deiner Schule ({contactNames}) und erkundige dich darüber, wie ihr als Schule fobizz weiterhin nutzen könnt. | Sprich mit den Ansprechpersonen deiner Schule ({contactNames}) und erkundige dich darüber, wie ihr als Schule fobizz weiterhin nutzen könnt.",
          "hintText": "Tipp: Alternativ findest du hier Informationen zu",
          "hintLink": "individuellen Abos",
          "hintSuffix": "zur persönlichen Nutzung."
        },
        "admin": {
          "heading": "Ihre Lizenz ist leider beendet.",
          "paragraph": "Als Ansprechperson für die Schule können Sie weiterhin den {reportsLink} besuchen. Dort können Sie auch die {extendLink}.",
          "reportsLink": "Verwaltungsbereich",
          "extendLink": "Schullizenz verlängern"
        },
        "salesContact": {
          "heading": "Herzlich willkommen im Verwaltungsbereich Ihrer Schule",
          "textPrefix": "Gerne berate ich Sie in allen Fragen rund um Ihre Schullizenz. Sie erreichen mich unter",
          "textMiddle": "Wenn Sie hier einen",
          "calendarLink": "Telefontermin",
          "textSuffix": "wählen, rufe ich Sie zurück."
        }
      },
      "csv": "CSV exportieren",
      "print": "Drucken",
      "platformStats": {
        "allEnrollmentsCount": "Einschreibung über alle Lizenzen | Einschreibungen über alle Lizenzen",
        "membershipsCount": "Mitglied | Mitglieder",
        "continueUsingPart": "wollen fobizz weiter nutzen"
      },
      "toolsStats": {
        "digitalTools": "genutzte Tools und erstellte Materiallien",
        "pinboardsAndTeacherboards": "Pinnwände und Tafeln",
        "wordcloudsAndWebsites": "Wortwolken und Webseiten",
        "worksheetsAndSurveys": "Arbeitsblätter und Umfragen",
        "texteditor": "Textdokument | Textdokumente",
        "audiorecords": "Audioaufnahmen",
        "screenAndVideorecorder": "Video-Aufnahmen",
        "linksAndFilesharing": "Kurzlinks und Dateien",
        "aiTools": "gesendete KI-Prompts",
        "sharedSpaces": "angelegte KI-Klassenräume",
        "sharedSpaceLinkInviteesCount": "Schüler*innen in KI-Klassenräumen"
      }
    }
  }
}
